import { providerColumns } from '../components';

export const vendorColumns = {
  ...providerColumns,
  EMAIL: 'email',
};
